import { NotificationDataBuilder } from '../notifications-classes'

export class ActivityPlanNotification extends NotificationDataBuilder {
  constructor(props) {
    super(props)
  }
  setOnClick(onClick) {
    this.onClick = onClick
  }
}
